import React, { Fragment } from 'react';
import AliceCarousel from 'react-alice-carousel';

const handleDragStart = (e) => e.preventDefault();

const responsive = {
    0: { items: 1 },
    600: { items: 2 },
    1024: { items: 3 },
};

const HistoryBlock = (props) => {
    const block = props.result.find((x) => x.blockId === props.blockId);
    const getHistoryItem = (historyItem) => {
        const result = [];
        historyItem.forEach((x) => {
            result.push(
                <div className="historyBlock__carousel-item--textContainer">
                    <div
                        className="historyBlock__carousel-item--textContainer--inner"
                        onDragStart={handleDragStart}
                        role="presentation"
                    >
                        {x.imageViewModel && (
                            <div className='historyBlock__carousel-item--image-container'>
                                <img src={x.imageViewModel.url} alt={x.imageViewModel.alt} />
                            </div>
                        )
                        }
                        {x.topTitle && (
                            <h4 className="historyBlock__carousel-item--topTitle">
                                {x.topTitle}
                            </h4>
                        )}
                        {x.subTitle && (
                            <p
                                className="historyBlock__carousel-item--subtitle"
                                dangerouslySetInnerHTML={{ __html: x.subTitle }}
                            ></p>
                        )}
                        {x.bodyText && (
                            <p
                                className="historyBlock__carousel-item--bodyText"
                                dangerouslySetInnerHTML={{ __html: x.bodyText }}
                            ></p>
                        )}
                    </div>
                </div>
            );
        });
        return result;
    };

    return block && block.historyItems?.length > 0 ? (
        <div className='grid-system grid-system-within-boundaries' >
            <div className="grid-full-width">
                <div className="historyBlock" >
                    <div className="historyBlock__carousel">
                        <AliceCarousel
                            responsive={responsive}
                            mouseTracking
                            items={getHistoryItem(block.historyItems)}
                            infinite
                            renderNextButton={() => {
                                return (
                                    <div className="historyBlock__carousel-next">
                                        <span></span>
                                    </div>
                                );
                            }}
                            renderPrevButton={() => {
                                return (
                                    <div className="historyBlock__carousel-prev">
                                        <span></span>
                                    </div>
                                );
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Fragment></Fragment>
    );
};
export default HistoryBlock;
